<template>
  <v-card-text>
    <v-select
      v-model="viewStyle.viewType"
      label="Способ отображения элементов"
      :items="polygonViewTypes"
    />
    <template v-if="isCommonType">
      <v-card-text>
        <v-menu
          :close-on-content-click="false"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :color="viewStyle.lineColor"
              :class="[`${getTextColor(viewStyle.lineColor)}--text`]"
              class="mr-4"
              small
              dark
              rounded
              v-bind="attrs"
              v-on="on"
            >
              Цвет линий
            </v-btn>
          </template>

          <v-card>
            <v-color-picker
              v-model="viewStyle.lineColor"
              mode="rgba"
              flat
            />
          </v-card>
        </v-menu>
        <v-slider
          v-model="viewStyle.lineWidth"
          class="mt-5"
          label="Толщина линий"
          thumb-label
          max="10"
          min="0"
        />
        <v-slider
          v-model="viewStyle.lineOpacity"
          label="Прозрачность линий"
          step="0.1"
          min="0"
          max="1"
          thumb-label
        />
      </v-card-text>
    </template>
    <template v-else>
      <v-card-text>
        <v-select
          v-model="viewStyle.referenceProperty"
          hide-details
          return-object
          item-value="key"
          item-text="value"
          label="Поле, значение которого будет использоваться"
          no-data-text="Необходимо заполнить список полей"
          :items="mappings"
        />

        <div v-if="viewStyle.referenceProperty" class="mt-5">
          <v-slider
            v-model="viewStyle.lineWidth"
            class="mt-5"
            label="Толщина линий"
            thumb-label
            max="10"
            min="0"
          />
          <v-slider
            v-model="viewStyle.lineOpacity"
            label="Прозрачность линий"
            step="0.1"
            min="0"
            max="1"
            thumb-label
          />
          <h4>Цвет по значениям из поля:</h4>
          <v-row
            v-for="(stop, index) in viewStyle.stops"
            :key="index"
            align="center"
          >
            <v-col md="6">
              <v-text-field
                v-model="stop.value"
                label="Значение"
                hide-details
                :disabled="isMappingsEmpty"
              />
            </v-col>

            <v-col md="2">
              <v-menu
                offset-x
                :close-on-content-click="false"
                :disabled="isMappingsEmpty"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="stop.lineColor"
                    :class="[`${getTextColor(stop.lineColor)}--text`]"
                    class="mr-4"
                    small
                    dark
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  >
                    Цвет линий
                  </v-btn>
                </template>

                <v-card>
                  <v-color-picker
                    v-model="stop.lineColor"
                    flat
                  />
                </v-card>
              </v-menu>
            </v-col>

            <v-col md="1">
              <v-btn
                color="error"
                text
                :disabled="isMappingsEmpty"
                @click="viewStyle.stops.splice(index, 1)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-btn
            color="primary"
            class="mt-2"
            small
            text
            :disabled="isMappingsEmpty"
            @click="createStop"
          >
            Добавить цвет
          </v-btn>
        </div>
      </v-card-text>
    </template>
  </v-card-text>
</template>

<script>
import getTextColor, { getHexColor } from '@/utils/get-text-color';

const LINE_VIEW_TYPES = [
  { value: 'common', text: 'Общий' },
  { value: 'interpolation', text: 'Интерполяция цвета' },
  { value: 'match-colors', text: 'Цвет по значениям' },
];

const createStop = () => ({
  lineColor: '#eeeeee',
  value: null,
});

export default {
  name: 'line-view-settings',

  props: {
    viewStyle: {
      type: Object,
      required: true,
    },
    mappings: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      polygonViewTypes: LINE_VIEW_TYPES,
    };
  },

  computed: {
    isMappingsEmpty() {
      return !this.mappings.length;
    },

    isCommonType() {
      return this.viewStyle.viewType === 'common';
    },
  },

  created() {
    this.fixColor();
  },

  methods: {
    getTextColor,

    createStop() {
      this.viewStyle.stops.push(createStop());
    },

    fixColor() {
      this.viewStyle.lineColor = getHexColor(this.viewStyle.lineColor);
    },
  },
};
</script>
